import { GuestSiteComponentProps } from '@apps/websiteCustomJsonComponents/types';
import React, { useMemo } from 'react';
import { useGeneralEventScheduleGuest } from '../hooks/useGeneralEventScheduleGuest';
import { useEventInfo } from '@shared/utils/eventInfo';
import { ScheduleDisplay } from './ScheduleDisplay';
import { ScheduleDisplayTypes } from '../schedule.types';

export type GeneralScheduleData = {
  displayType: ScheduleDisplayTypes;
  exclusiveDayFilter?: string[];
};

// Tip:
// This is the component that is rendered on the guest site.
export const GeneralScheduleGuest = (props: GuestSiteComponentProps) => {
  const eventData = useEventInfo();
  const componentMetadata = props.data.content as GeneralScheduleData;
  const { schedule } = useGeneralEventScheduleGuest(eventData.eventInfo?.eventId ?? '');

  const filteredDays = useMemo(() => {
    if (!schedule?.formattedSchedules) {
      return null;
    }
    const days = schedule.formattedSchedules;
    return days.filter(d => {
      if (!componentMetadata.exclusiveDayFilter) {
        return true;
      }
      return !componentMetadata.exclusiveDayFilter.includes(d.dateISO8601TZ);
    });
  }, [componentMetadata.exclusiveDayFilter, schedule]);

  return (
    <ScheduleDisplay
      type={componentMetadata.displayType}
      data={filteredDays}
    />
  );
};
